/**
 * D6PVLTConditionType - Condition qui vérifie si les PV sont inférieurs à une valeur
 * Identique à Java PVLTCondition
 */

import {ConditionType} from '../../types/ConditionType';
import {GameState} from '../../../models/GameState';
import GameStateHelper from '../../../helpers/GameStateHelper';

export class D6PVLTConditionType implements ConditionType {
  typeName = 'D6_COND_PV_LT';
  messageKey = 'laventurier.condition.d6.pv-lt.name';
  descriptionKey = 'laventurier.condition.d6.pv-lt.desc';
  errorKey = 'laventurier.condition.d6.pv-lt.error';
  hasValue = true;
  hasAttribute = false;

  evaluate(gameState: GameState, condition: any): boolean {
    const threshold = parseInt(condition.value || condition.threshold || '0', 10);
    if (isNaN(threshold)) {
      console.log('[D6PVLTConditionType] FALSE: invalid threshold value');
      return false;
    }

    const pvField = GameStateHelper.getAdventureExtraField(gameState, 'D6_PV');
    if (!pvField) {
      console.log('[D6PVLTConditionType] FALSE: D6_PV field not found');
      return false;
    }

    const currentPV = parseInt(String(pvField.currentValue || pvField.initValue || '0'), 10);
    const result = currentPV < threshold;
    console.log(`[D6PVLTConditionType] ${result ? 'TRUE' : 'FALSE'}: currentPV=${currentPV}, threshold=${threshold}`);
    return result;
  }
}
